import { Autocomplete, TextField, Typography } from "@mui/material";
import { ChangeEvent, FC } from "react";

interface IProps {
    error?: string;
    isDisabled?: boolean;
    title: string;
    value: any | null;
    handleChangeValue: any;
    optionList: any[];
    changeText?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const TextAutocomplete: FC<IProps> = ({ value, handleChangeValue, optionList, title, changeText, error, isDisabled }) => {

    return (
        <Autocomplete
            disablePortal
            fullWidth
            onChange={(e, value) => handleChangeValue(value)}
            value={value}
            options={optionList}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(params, option): JSX.Element => (
                <Typography {...params} key={option.id} p={1}>
                    {option.name}
                </Typography>
            )}
            renderInput={(params): JSX.Element => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={title}
                    onChange={changeText}
                    helperText={
                        <Typography variant="caption" color="error" >
                            {error}
                        </Typography>}
                />
            )}
            clearIcon={false}
            disabled={isDisabled}
        />
    )
};
